import rest from '../rest';
import { scriptCount, scriptsDatesCount } from './scriptsResponse';

const scripts = [
	rest.get(`/api/v2/scripts/allocation/count/:year/:types`, (req, res, ctx) => res(ctx.json(scriptCount))),
	rest.get(`/api/v2/scripts/dates/count/:year/:types`, (req, res, ctx) => res(ctx.json(scriptsDatesCount)))
];

export default scripts;
